import {
  Box,
  Typography,
  Paper,
  Button,
  Alert,
  Breadcrumbs,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  NavigateNext as NavigateNextIcon,
  CheckCircle as CheckIcon,
  Schedule as ScheduleIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const Trading212ApiPage = () => {
  const navigate = useNavigate();

  const features = [
    "Automatic portfolio synchronization",
    "Real-time transaction updates", 
    "No manual CSV uploads required",
    "Live position tracking",
    "Automatic dividend recording",
    "Historical data backfill",
  ];

  return (
    <Box sx={{ p: 3, maxWidth: 800, mx: "auto" }}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        sx={{ mb: 3 }}
      >
        <Link
          color="inherit"
          href="#"
          onClick={(e) => {
            e.preventDefault();
            navigate("/portfolio");
          }}
          sx={{ cursor: "pointer" }}
        >
          Portfolio
        </Link>
        <Link
          color="inherit"
          href="#"
          onClick={(e) => {
            e.preventDefault();
            navigate("/portfolio/trading212");
          }}
          sx={{ cursor: "pointer" }}
        >
          Trading212
        </Link>
        <Typography color="text.primary">API Integration</Typography>
      </Breadcrumbs>

      <Typography variant="h4" component="h1" gutterBottom>
        Trading212 API Integration
      </Typography>
      
      <Typography variant="body1" color="text.secondary" paragraph>
        Connect your Trading212 account directly for automatic portfolio synchronization and real-time updates.
      </Typography>

      <Paper sx={{ p: 4, mt: 3, textAlign: "center" }}>
        <ScheduleIcon sx={{ fontSize: 64, color: "text.secondary", mb: 2 }} />
        <Typography variant="h5" gutterBottom>
          Coming Soon
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          We're working on bringing you seamless API integration with Trading212. 
          This feature will allow automatic synchronization of your portfolio data.
        </Typography>
      </Paper>

      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          What you'll get with API integration:
        </Typography>
        <List>
          {features.map((feature, index) => (
            <ListItem key={index} sx={{ pl: 0 }}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <CheckIcon color="success" />
              </ListItemIcon>
              <ListItemText primary={feature} />
            </ListItem>
          ))}
        </List>
      </Box>

      <Alert severity="info" sx={{ mt: 3 }}>
        <Typography variant="body2">
          <strong>Want to get started now?</strong>
          <br />
          While we work on API integration, you can upload your Trading212 CSV export 
          to start analyzing your portfolio immediately.
        </Typography>
      </Alert>

      <Box sx={{ mt: 3, display: "flex", gap: 2, justifyContent: "center" }}>
        <Button
          variant="outlined"
          onClick={() => navigate("/portfolio/trading212")}
        >
          Back to Trading212
        </Button>
        <Button
          variant="contained"
          onClick={() => navigate("/portfolio/trading212/csv")}
        >
          Try CSV Upload Instead
        </Button>
      </Box>

      <Box 
        sx={{ 
          mt: 4, 
          p: 3, 
          backgroundColor: "rgba(0, 0, 0, 0.04)", 
          borderRadius: 2,
          border: "1px solid rgba(0, 0, 0, 0.12)"
        }}
      >
        <Typography variant="h6" gutterBottom>
          Get notified when it's ready
        </Typography>
        <Typography variant="body2" color="text.secondary">
          We'll email you as soon as Trading212 API integration is available. 
          In the meantime, CSV upload provides the same portfolio analysis capabilities.
        </Typography>
      </Box>
    </Box>
  );
};

export default Trading212ApiPage;